import mitt from './mitt';

type App = any;
const innerEventBus = mitt();
export interface Options {
  // 是否挂载在全局
  global?: boolean;
  // 是否 provide
  inject?: boolean;
  // 实例上挂载的名称
  globalPropertyName?: string;
  // 通过 inject 引入的名称
  injectName?: string;
}


const eventBus: ReturnType<typeof mitt> & {
  install: (app: App, options?: Options) => void;
} = {
  ...innerEventBus,
  install,
};


const DEFAULT_OPTIONS = {
  global: false,
  inject: false,
  globalPropertyName: '$eventBus',
  injectName: '$eventBus',
};


eventBus.install = install;

export default eventBus;
export const bus = eventBus;


function install(app: App, options?: Options) {
  const opt = {
    ...DEFAULT_OPTIONS,
    ...(options || {}),
  };

  if (opt.global && opt.globalPropertyName) {
    app.config.globalProperties[opt.globalPropertyName] = eventBus;
  }

  if (opt.inject && opt.injectName) {
    app.provide(opt.injectName, eventBus);
  }

  return eventBus;
}
